import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {NotificheComponent} from './notifiche';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {
  $stateProvider
    .state('home.notifiche', {
      url: '/notifiche',
      ncyBreadcrumb: {
        label: 'Notifiche Page'
      },
      data: {
        authorisationLevel: 1,
        pageTitle: 'Notifiche Page'
      },
      views: {
        homeContent: {
          template: '<notifiche flex="100"></notifiche>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const NotificheModule: string = ng
  .module('notifiche', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('notifiche', NotificheComponent)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/notifiche/notifiche.module.ts